<script setup>
import { BreadCrumb } from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/index'

const props = defineProps({
  breadCrumbList: {
    type: Array,
    default: () => []
  }
})

const { checkId } = useSgtkStatus()
useCustomJsonld(props.breadCrumbList)

onBeforeMount(() => {
  if (window.history && window.history.pushState) {
    const fixedPath = '/cs/cpsite.html'
    const queryParams = window.location.search
    window.history.replaceState('', document.title, fixedPath + queryParams)
  }
  checkId()
})
</script>

<template>
  <div class="main">
    <CommonHeaderComponent />
    <div class="content">
      <BreadCrumb
        v-if="breadCrumbList.length > 0"
        :bread-crumb-list="breadCrumbList"
        :is-web-view-prop="true"
      />
      <slot />
    </div>
    <CommonFooterComponent />
  </div>
</template>

<style>
html {
  scroll-behavior: unset;
}
</style>

<style scoped>
.main{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 15px;
  max-width: 800px;
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
}
</style>
